module.exports = __webpack_public_path__ + "img/little-logo-white.1a669a6a.png";